<template>
  <CCard>
    <CCardBody>
      <CRow>
        <CCol xl="6">
          <CCard v-if="areFiltersVisible">
            <CCardHeader @click="areFiltersVisible = false">
              Filteri
              <div class="card-header-actions">
                <CIcon name="cil-chevron-top" />
              </div>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol xl="6" class="d-none">
                  <CSelect description="Zupanija" :value.sync="selectedRegion" :options="['Split i okolica', 'Zagreb', 'Sve']" />
                </CCol>
                <CCol>
                  <div class="hood-filter-row">
                    <multiselect placeholder="Filter po kvartu" v-model="selectedHoods" label="name" track-by="code" :options="hoodDropdown.all" :multiple="true" :taggable="true"></multiselect>
                    <CButton color="secondary" size="sm" class="hood-clear-button" :disabled="selectedHoods.length === 0" @click="clearSelectedHoods">
                      Makni sve kvartove
                    </CButton>
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol> </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <multiselect placeholder="Filter po agenciji" v-model="selectedPublishers" label="name" track-by="code" :options="publisherOptions" :multiple="true"></multiselect>
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <CInput description="Cijena od (€)" placeholder="Cijena od (€)" :value.sync="minPrice" />
                </CCol>
                <CCol>
                  <CInput description="Cijena do (€)" placeholder="Cijena do (€)" :value.sync="maxPrice" />
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <CInput description="Velicina od (m2)" placeholder="Velicina od (m2)" :value.sync="minSize" />
                </CCol>
                <CCol>
                  <CInput description="Velicina do (m2)" placeholder="Velicina do (m2)" :value.sync="maxSize" />
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <CInput description="Novije od" placeholder="Novije od" @change="onFromDateChange" :value.sync="fromDate" type="date" />
                </CCol>
              </CRow>
              <CRow>
                <CCol xl="3">
                  <CInput description="Njuskalo Id" placeholder="Njuskalo Id" :value.sync="filterByNjuskaloId" />
                </CCol>
              </CRow>

              <CRow>
                <CCol>
                  <label class="switch">
                    Aktivni / neaktivni
                    <CSwitch class="mx-1" color="info" shape="pill" :checked.sync="showOnlyActiveAds" />
                  </label>
                </CCol>
                <CCol>
                  <label class="switch">
                    Samo s garazom
                    <CSwitch class="mx-1" color="info" shape="pill" :checked.sync="hasGarage" />
                  </label>
                </CCol>
                <CCol>
                  <label class="switch">
                    Prodaje vlasnik
                    <CSwitch class="mx-1" color="info" shape="pill" :checked.sync="isAdPublisherEstateOwner" />
                  </label>
                </CCol>
                <CCol>
                  <label class="switch">
                    Novogradnja
                    <CSwitch class="mx-1" color="info" shape="pill" :checked.sync="isNewlyBuilt" />
                  </label>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <a :class="isAdTypeProdaja ? 'nav-link active' : 'nav-link'" @click="selectAdType(true)">Prodaja</a>
            </li>
            <li class="nav-item" @click="selectAdType(false)">
              <a :class="isAdTypeProdaja ? 'nav-link' : 'nav-link active'">Najam</a>
            </li>
            <li class="nav-item">
              <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">
                oglasa: <strong>{{ visiblePropertyCount }} </strong>
              </a>
            </li>
            <li class="nav-item d-flex align-items-center">
              <CButton color="secondary" size="sm" @click="areFiltersVisible = true">Filteri</CButton>
            </li>
          </ul>

          <div class="ads-table-shell" :class="{ 'ads-table-shell-loading': isEstateAdsLoading }" :aria-busy="isEstateAdsLoading ? 'true' : 'false'">
            <CDataTable :key="tableFilterRevision" @row-clicked="tableRowClicked" :hover="true" :striped="true" :items="estateAds" :fields="tableColumns" :sorter="!hasExpandedPropertyGroups" :class="['hover', 'ads-table', { 'ads-table-content-loading': isEstateAdsLoading }, displayedIsAdTypeProdaja ? 'ads-table-sale' : 'ads-table-rent']">
              <template slot="no-items-view">
                <span class="d-none" aria-hidden="true"></span>
              </template>
            <td slot="createdAt" slot-scope="{ item }" class="text-center" :class="isToday(item.createdAt) ? 'text-info' : ''">
              <span :title='getDateText(item.createdAt)'>{{ getDateTextAgo(item.createdAt) }}</span>
            </td>
            <td slot="hoodInfo" slot-scope="{ item }" class="text-center">
              <span v-if="item.isGroupChild" class="group-child-marker" title="Oglas unutar grupe">↳</span>
              <strong>{{ getShortHoodText(item.hood) }}</strong>
            </td>
            <td slot="size" slot-scope="{ item }" class="text-center">{{ item.size }}</td>
            <td slot="hood" slot-scope="{ item }" class="text-left group-description-cell">
              <span v-if="item.type">
                <span class="ad-source-label">{{ getSourceText(item.source) }}; </span>
                <strong v-if="item.adPublisher">{{ item.adPublisher.slice(0, 10) }}; </strong>
                <CIcon v-if="item.hasGarage" name="cil-car-alt" class="property-feature-icon" title="garaža" aria-label="garaža" />
                <CIcon v-if="item.type === 'Samostojeća kuća'" name="cil-house" class="property-feature-icon" title="samostojeća kuća" aria-label="samostojeća kuća" />
                <span v-else-if="item.type !== 'Stan u stambenoj zgradi'">{{ getShortTypeText(item.type) }};</span>
                {{ getShortFloorText(item.floor) }}
              </span>
              <span v-else class="text-muted">obrada u tijeku</span>
              <CButton
                v-if="item.propertyGroupSize > 1 && !item.isGroupChild"
                color="link"
                size="sm"
                class="group-expand-button p-0"
                @click.stop="togglePropertyGroup(item)"
                :title="isPropertyGroupExpanded(item.propertyGroupId) ? 'Sakrij ostale oglase' : 'Prikaži ostale oglase'"
                :aria-label="isPropertyGroupExpanded(item.propertyGroupId) ? 'Sakrij ostale oglase' : 'Prikaži ostale oglase'"
              >
                <span class="group-expand-count">{{ item.propertyGroupSize - 1 }}</span>
                <CIcon :name="isPropertyGroupExpanded(item.propertyGroupId) ? 'cil-chevron-top' : 'cil-chevron-bottom'" />
              </CButton>
            </td>
            <td slot="pricePerSqm" slot-scope="{ item }" class="text-center">
              <strong>{{ item.pricePerSqm.toLocaleString() }}</strong>
            </td>
            <td slot="price" slot-scope="{ item }" class="text-center">
              <span :style="getPriceStyle(item.price)">{{ item.price.toLocaleString() }}</span>
            </td>
            <td slot="hoodDiff" slot-scope="{ item }" class="text-center">
              <div class="d-flex align-items-center justify-content-center">
                <strong v-if="item.hoodDiff !== null" :class="item.hoodDiff > 0 ? 'text-danger' : item.hoodDiff < 0 ? 'text-success' : ''">
                  {{ item.hoodDiff + "%" }}
                </strong>
                <span v-else class="text-muted">—</span>
                <span class="ml-1">
                  {{ item.hoodPrice !== null ? `${item.hoodPrice.toLocaleString()} (${item.hoodCount})` : "—" }}
                </span>
              </div>
            </td>
            </CDataTable>
            <div v-if="isEstateAdsLoading" class="ads-loading-overlay" role="status" aria-label="Učitavanje oglasa">
              <CSpinner class="ads-loading-spinner" />
            </div>
          </div>
          <CPagination v-if="pageCount > 1" :activePage.sync="currentPage" :pages="pageCount" align="center" />
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>

<script>
import moment from "moment";
import { getPriceColor } from "../services/priceColor";
import Multiselect from "vue-multiselect";
import { estateAdService } from "../services/services";
export default {
  name: "Table",
  components: { Multiselect },
  props: {
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
  },
  mounted() {
    this.getEstateAds();
  },
  data: function() {
    let gradoviSplitIOkolica = ["Kaštela", "Solin", "Solin - Okolica", "Split", "Split - Okolica"];
    const defaultSelectedHoods = ["Duilovo", "Žnjan", "Visoka", "Mertojak", "Split 3", "Trstenik", "Bačvice", "Sirobuja", "Mejaši", "Pazdigrad", "Kila"];

    let allHoods = this.$store.state.hoods.filter((h) => gradoviSplitIOkolica.includes(h.city));
    allHoods.sort(function(a, b) {
      return b.count - a.count;
    });
    allHoods = allHoods.map((h) => h.hood);
    allHoods = [...new Set(allHoods)].map((h) => {
      return { code: h, name: h };
    });
    return {
      showOnlyActiveAds: true,
      filterByNjuskaloId: null,
      hasGarage: false,
      isAdTypeProdaja: true,
      displayedIsAdTypeProdaja: true,
      isAdPublisherEstateOwner: false,
      isNewlyBuilt: false,
      hoodDropdown: {
        all: allHoods,
      },
      selectedHoods: allHoods.filter((hood) => defaultSelectedHoods.includes(hood.code)),
      selectedPublishers: [],
      expandedPropertyGroupIds: [],
      propertyGroupAds: {},
      tableFilterRevision: 0,
      allEstateAds: [],
      publisherOptions: [],
      totalAds: 0,
      currentPage: 1,
      itemsPerPage: 100,
      reloadTimeout: null,
      requestRevision: 0,
      isEstateAdsLoading: true,
      gradoviSplitIOkolica,
      selectedRegion: "Split i okolica",
      minSize: null,
      maxSize: null,
      minPrice: null,
      areFiltersVisible: false,
      maxPrice: null,
      fromDate: moment()
        .add(-3, "month")
        .startOf("day")
        .format("YYYY-MM-DD"),
    };
  },
  computed: {
    tableColumns() {
      return this.displayedIsAdTypeProdaja
        ? [
            { key: "createdAt", label: "🕒" },
            { key: "hoodInfo", label: "kvart" },
            { key: "pricePerSqm", label: "€/m2" },
            { key: "price", label: "cijena €" },
            { key: "size", label: "m2" },
            { key: "hoodDiff", label: "kvart €/m2" },
            { key: "hood", label: "ostalo" },
          ]
        : [
            { key: "createdAt", label: "🕒" },
            { key: "hoodInfo", label: "kvart" },
            { key: "price", label: "cijena €" },
            { key: "size", label: "m2" },
            { key: "hood", label: "ostalo" },
          ];
    },

    estateAds() {
      const rows = [];
      this.allEstateAds.forEach((ad) => {
        rows.push({ ...ad, isGroupChild: false });
        if (!this.isPropertyGroupExpanded(ad.propertyGroupId)) return;
        const groupAds = this.propertyGroupAds[ad.propertyGroupId] || [];
        groupAds.filter((groupAd) => groupAd.id !== ad.id).forEach((groupAd) => {
          rows.push({
            ...groupAd,
            isGroupChild: true,
            parentPropertyGroupId: ad.propertyGroupId,
            _classes: "group-child-row",
          });
        });
      });
      return rows;
    },
    visiblePropertyCount() {
      return this.isEstateAdsLoading ? "…" : this.totalAds;
    },
    hasExpandedPropertyGroups() {
      return this.expandedPropertyGroupIds.length > 0;
    },
    pageCount() {
      return this.isEstateAdsLoading ? 0 : Math.ceil(this.totalAds / this.itemsPerPage);
    },
    filterRequestState() {
      return {
        fromDate: this.fromDate,
        hasGarage: this.hasGarage,
        adType: this.isAdTypeProdaja ? "prodaja" : "najam",
        showOnlyActiveAds: this.showOnlyActiveAds,
        ownerOnly: this.isAdPublisherEstateOwner,
        newlyBuiltOnly: this.isNewlyBuilt,
        region: this.selectedRegion,
        hoods: this.selectedHoods.map((hood) => hood.code),
        publishers: this.selectedPublishers.map((publisher) => publisher.code),
        minSize: this.minSize,
        maxSize: this.maxSize,
        minPrice: this.minPrice,
        maxPrice: this.maxPrice,
        externalId: this.filterByNjuskaloId,
      };
    },
    filterRequestKey() {
      return JSON.stringify(this.filterRequestState);
    },
    nonTypeFilterRequestKey() {
      const filters = { ...this.filterRequestState };
      delete filters.adType;
      return JSON.stringify(filters);
    },
  },

  watch: {
    isAdTypeProdaja() {
      this.invalidateEstateAds();
      this.cancelScheduledEstateAdsReload();
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      } else {
        this.getEstateAds();
      }
    },
    nonTypeFilterRequestKey() {
      this.invalidateEstateAds();
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      } else {
        this.scheduleEstateAdsReload();
      }
    },
    currentPage() {
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.invalidateEstateAds();
      this.getEstateAds();
    },
    "$store.state.messages": function() {
      if (this.$store.state.messages.length > 0) {
        let isScrapeFinished = this.$store.state.messages[0].text.startsWith("job zavrsen");
        let wasScrapeInProgressNowFinished = this.isScrapeInProgress && isScrapeFinished;
        if (wasScrapeInProgressNowFinished) {
          this.getEstateAds();
        }
        this.isScrapeInProgress = !isScrapeFinished;
      }
    },
  },

  beforeDestroy() {
    if (this.reloadTimeout) clearTimeout(this.reloadTimeout);
  },

  methods: {
    selectAdType(isSale) {
      this.isAdTypeProdaja = isSale;
    },
    cancelScheduledEstateAdsReload() {
      if (!this.reloadTimeout) return;
      clearTimeout(this.reloadTimeout);
      this.reloadTimeout = null;
    },
    invalidateEstateAds() {
      this.requestRevision += 1;
      this.isEstateAdsLoading = true;
    },
    clearSelectedHoods() {
      this.selectedHoods = [];
    },
    isPropertyGroupExpanded(propertyGroupId) {
      return propertyGroupId && this.expandedPropertyGroupIds.includes(propertyGroupId);
    },
    togglePropertyGroup(item) {
      const propertyGroupId = item.propertyGroupId;
      if (!propertyGroupId) {
        return;
      }
      if (this.isPropertyGroupExpanded(propertyGroupId)) {
        this.expandedPropertyGroupIds = this.expandedPropertyGroupIds.filter((id) => id !== propertyGroupId);
      } else {
        if (!this.propertyGroupAds[propertyGroupId]) {
          const filterKey = this.filterRequestKey;
          return estateAdService.getPropertyGroupAds(propertyGroupId, this.fromDate, this.hasGarage).then((response) => {
            if (filterKey !== this.filterRequestKey) return;
            this.$set(this.propertyGroupAds, propertyGroupId, this.decorateEstateAds(response.body));
            this.expandedPropertyGroupIds = [...this.expandedPropertyGroupIds, propertyGroupId];
            this.tableFilterRevision += 1;
          });
        }
        this.expandedPropertyGroupIds = [...this.expandedPropertyGroupIds, propertyGroupId];
      }
      this.tableFilterRevision += 1;
    },
    tableRowClicked(row) {
      window.open(row.link, "_blank", "noopener,noreferrer");
      return false;
    },
    getEstateAds() {
      this.cancelScheduledEstateAdsReload();
      const requestRevision = ++this.requestRevision;
      const filterKey = this.filterRequestKey;
      const requestedIsAdTypeProdaja = this.isAdTypeProdaja;
      this.isEstateAdsLoading = true;
      return estateAdService
        .searchEstateAds(this.getEstateAdParams())
        .then((response) => {
          if (requestRevision !== this.requestRevision || filterKey !== this.filterRequestKey) return;
          this.displayedIsAdTypeProdaja = requestedIsAdTypeProdaja;
          this.allEstateAds = this.decorateEstateAds(response.body.items);
          this.totalAds = response.body.total;
          this.publisherOptions = response.body.publishers.map((publisher) => ({ code: publisher, name: publisher }));
          this.expandedPropertyGroupIds = [];
          this.propertyGroupAds = {};
          this.tableFilterRevision += 1;
        })
        .catch(() => {
          if (requestRevision !== this.requestRevision || filterKey !== this.filterRequestKey) return;
          this.displayedIsAdTypeProdaja = requestedIsAdTypeProdaja;
          this.allEstateAds = [];
          this.totalAds = 0;
        })
        .finally(() => {
          if (requestRevision !== this.requestRevision || filterKey !== this.filterRequestKey) return;
          this.isEstateAdsLoading = false;
        });
    },
    scheduleEstateAdsReload() {
      this.cancelScheduledEstateAdsReload();
      this.reloadTimeout = setTimeout(() => this.getEstateAds(), 250);
    },
    getEstateAdParams() {
      const regionCodes = { "Split i okolica": "split", Zagreb: "zagreb", Sve: "all" };
      return {
        fromDate: this.fromDate,
        hasGarage: this.hasGarage,
        adType: this.isAdTypeProdaja ? "prodaja" : "najam",
        showOnlyActiveAds: this.showOnlyActiveAds,
        ownerOnly: this.isAdPublisherEstateOwner,
        newlyBuiltOnly: this.isNewlyBuilt,
        region: regionCodes[this.selectedRegion] || "all",
        hoods: JSON.stringify(this.selectedHoods.map((hood) => hood.code)),
        publishers: JSON.stringify(this.selectedPublishers.map((publisher) => publisher.code)),
        minSize: this.minSize,
        maxSize: this.maxSize,
        minPrice: this.minPrice,
        maxPrice: this.maxPrice,
        externalId: this.filterByNjuskaloId,
        page: this.currentPage,
        limit: this.itemsPerPage,
      };
    },
    decorateEstateAds(estateAds) {
      const hoodAverages = new Map(this.$store.state.hoods.map((hood) => [`${hood.city}|${hood.hood}|${hood.type}`, hood]));
      return estateAds.map((ad) => {
        const hoodAverage = hoodAverages.get(`${ad.city}|${ad.hood}|${ad.type}`);
        return {
          ...ad,
          hoodPrice: hoodAverage ? hoodAverage.pricePerSqm : null,
          hoodCount: hoodAverage ? hoodAverage.count : null,
          hoodDiff: hoodAverage ? parseInt(((ad.pricePerSqm - hoodAverage.pricePerSqm) / hoodAverage.pricePerSqm) * 100) : null,
        };
      });
    },
    onFromDateChange(newValue) {
      this.fromDate = newValue;
    },
    getSumary() {
      return "test";
    },
    getDateText(date) {
      return moment(date).format("YYYY-MM-DD hh:mm");
    },
    getDateTextAgo(date) {
      const adDate = moment(date);
      const now = moment();
      const minutesAgo = Math.max(0, now.diff(adDate, "minutes"));

      if (minutesAgo < 60) {
        return `${minutesAgo}min`;
      }

      const hoursAgo = now.diff(adDate, "hours");
      if (hoursAgo < 24) {
        return `${hoursAgo}h`;
      }

      const monthsAgo = now.diff(adDate, "months");
      if (monthsAgo < 1) {
        return `${now.diff(adDate, "days")}d`;
      }

      return `${monthsAgo}m`;
    },
    isToday(date) {
      return moment(date).isSame(new Date(), "day");
    },
    getShortTypeText(typeText) {
      const shortTexts = {
        "Stan u stambenoj zgradi": "stan zgrada",
        "Stambeno-poslovna kuća": "kuca",
        "U nizu kuća": "kuca",
        "Dvojna (duplex) kuća": "kuca",
        "Samostojeća kuća": "sama kuca",
        "Stan u kući": "stan kuca",
      };
      return shortTexts[typeText] ?? typeText;
    },
    getSourceText(source) {
      const sourceTexts = {
        index: "Index",
        nekretnine: "Nekretnine.hr",
        njuskalo: "Njuškalo",
      };
      return sourceTexts[source] ?? source;
    },
    getPriceStyle(price) {
      // Thresholds are sale prices; rent prices would all be green.
      const color = this.displayedIsAdTypeProdaja ? getPriceColor(price) : null;
      return color ? { color } : {};
    },
    getShortHoodText(hoodText) {
      return hoodText ? hoodText.replace("Kaštel ", "") : "";
    },
    getShortFloorText(floorText) {
      return floorText ? floorText.replace("visoko ", "") : floorText;
    },
  },
};
</script>
<style>
table a {
  color: inherit;
}
table {
  cursor: pointer;
}
table a:hover {
  text-decoration: none;
}
th {
  text-align: center;
  border-top: 0px !important;
}
.ads-table thead th > .c-icon {
  display: none;
}
.ads-table thead th.pr-4 {
  padding-right: 0.75rem !important;
}
.ads-table .table {
  table-layout: fixed;
  width: 100%;
}
@media (max-width: 767.98px) {
  .ads-table .table {
    min-width: 900px;
  }
}
.ads-table-sale .table th:nth-child(1) {
  width: 5%;
}
.ads-table-sale .table th:nth-child(2) {
  width: 11.5%;
}
.ads-table-sale .table th:nth-child(3) {
  width: 7.5%;
}
.ads-table-sale .table th:nth-child(4) {
  width: 10.7%;
}
.ads-table-sale .table th:nth-child(5) {
  width: 5.6%;
}
.ads-table-sale .table th:nth-child(6) {
  width: 18.3%;
}
.ads-table-sale .table th:nth-child(7) {
  width: 41.4%;
}
.ads-table-rent .table th:nth-child(1) {
  width: 7%;
}
.ads-table-rent .table th:nth-child(2) {
  width: 16%;
}
.ads-table-rent .table th:nth-child(3) {
  width: 15%;
}
.ads-table-rent .table th:nth-child(4) {
  width: 8%;
}
.ads-table-rent .table th:nth-child(5) {
  width: 54%;
}
.multiselect {
  margin-bottom: 1rem;
}
.hood-filter-row {
  display: flex;
  align-items: flex-start;
}
.hood-filter-row .multiselect {
  flex: 1 1 auto;
  min-width: 0;
}
.hood-clear-button {
  flex: 0 0 auto;
  margin-left: 0.75rem;
  white-space: nowrap;
}
.switch {
  padding-left: 15px;
}
.group-expand-button {
  color: #4f5d73;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  position: absolute;
  right: 0.5rem;
  top: calc(50% - 5.25px);
  min-width: 36px;
  height: 28px;
  font-size: 14px;
  padding: 0 6px !important;
  line-height: 18px;
  transform: translateY(-50%);
  vertical-align: middle;
}
.group-expand-count {
  font-size: inherit;
  font-weight: 600;
  line-height: 18px;
}
.group-expand-button svg {
  width: 14px !important;
  height: 14px !important;
}
.group-expand-button:hover,
.group-expand-button:focus {
  color: #321fdb;
  text-decoration: none;
}
.group-child-marker {
  color: #321fdb;
  font-size: 1rem;
  font-weight: 700;
  margin-right: 0.35rem;
}
.group-description-cell {
  position: relative;
}
.ads-table th:last-child,
.ads-table .table td.group-description-cell {
  text-align: left !important;
}
.ads-table .table tbody tr,
.ads-table .table tbody td {
  height: 36.4px !important;
}
.ads-table-shell {
  position: relative;
}
.ads-table-shell-loading {
  min-height: 96px;
}
.ads-table-content-loading {
  filter: blur(2px);
  opacity: 0.65;
  pointer-events: none;
  user-select: none;
}
.ads-loading-overlay {
  align-items: center;
  background: rgba(255, 255, 255, 0.22);
  cursor: wait;
  display: flex;
  inset: 0;
  justify-content: center;
  position: absolute;
  z-index: 2;
}
.ads-loading-spinner {
  color: #4f5d73;
  height: 2.25rem;
  opacity: 0.55;
  width: 2.25rem;
}
.ads-table .table tbody td {
  line-height: 18px;
  padding-bottom: 4px !important;
  padding-top: 4px !important;
  vertical-align: middle;
  white-space: nowrap;
}
.property-feature-icon {
  height: 14px !important;
  margin-right: 0.3rem;
  vertical-align: -2px;
  width: 14px !important;
}
.ads-table tr.group-child-row > td {
  background-color: #eef2f7 !important;
  border-top: 1px dashed #9da5b1;
}
.ads-table tr.group-child-row > td:first-child {
  box-shadow: inset 4px 0 #321fdb;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
